// someday upgrade to https://codesandbox.io/s/flamboyant-archimedes-0g7cf?file=/src/search-routing.js:991-2644
const catalogRouting = true;
export default catalogRouting;
